import { useAuth } from 'react-oidc-context';
import jwt_decode from 'jwt-decode';
import { CountryContext } from './useCountryContext';

interface AvailableCountries {
  countries: CountryContext[];
  loading: boolean;
}

interface IdentityToken {
  'Tenant.Code': string | string[];
}

const useAvailableCountries = (): AvailableCountries => {
  const auth = useAuth();

  if (auth.isLoading) {
    return {
      countries: [],
      loading: true,
    };
  }

  if (auth.user?.access_token) {
    const decodedToken = jwt_decode<IdentityToken>(auth.user?.access_token);
    const countryCodes = decodedToken['Tenant.Code'];

    if (typeof countryCodes === 'string' || countryCodes instanceof String) {
      return {
        countries: [
          CountryContext[countryCodes as keyof typeof CountryContext],
        ],
        loading: false,
      };
    }

    if (Array.isArray(countryCodes)) {
      const availableCountries: CountryContext[] = [];
      countryCodes.forEach((country) => {
        availableCountries.push(
          CountryContext[country as keyof typeof CountryContext],
        );
      });

      return {
        countries: availableCountries,
        loading: false,
      };
    }
  }

  return {
    countries: [],
    loading: false,
  };
};

export default useAvailableCountries;
